import { render, staticRenderFns } from "./PdfjsViewerContextMenu.vue?vue&type=template&id=09b66e41&scoped=true&"
import script from "./PdfjsViewerContextMenu.vue?vue&type=script&lang=ts&"
export * from "./PdfjsViewerContextMenu.vue?vue&type=script&lang=ts&"
import style0 from "./PdfjsViewerContextMenu.vue?vue&type=style&index=0&id=09b66e41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b66e41",
  null
  
)

export default component.exports